<template>
  <section>
    <b-card>
      <b-card-body>
        <h4 class="mt-2">
          مستندات وب‌سرویس
        </h4>
        <p>
          برای سهولت دسترسی به مستندات وب‌سرویس سیستم، لینک مستقیم به مجموعه Postman تهیه شده است. شما می‌توانید با استفاده از این لینک، به‌سرعت به اطلاعات لازم برای اتصال و کار با وب‌سرویس دسترسی پیدا کنید.
        </p>
        <h5 class="mt-2">
          <strong>ویژگی‌های مستندات:</strong>
        </h5>
        <ul>
          <li>شامل تمام اطلاعات لازم برای استفاده از API</li>
          <li>توضیحات کامل درباره‌ی پارامترها و پاسخ‌ها</li>
          <li>قابلیت تست مستقیم درخواست‌ها از طریق Postman</li>
          <li><strong>نمونه کدهای آماده برای زبان‌های برنامه‌نویسی مختلف</strong> (مانند C# ، JavaScript، PHP ، Java Python ، و ...)</li>
        </ul>
        <p>برای مشاهده و استفاده از مستندات، از لینک زیر استفاده کنید:</p>
        <a
          :href="appConfig.document_url"
          target="_blank"
        >
          {{ $t('Postman api') }}
        </a>
        <h4 class="mt-2">
          {{ $t('Webhook helper') }}
        </h4>
        <h5 class="mt-2">
          <strong>وب‌هوک چیست؟</strong>
        </h5>
        <p>وب‌هوک به شما امکان می‌دهد تا پیام‌های دریافتی را به‌صورت خودکار به سرور یا آدرس مشخصی ارسال کنید.</p>

        <h5>مراحل راه‌اندازی وب‌هوک</h5>

        <p><strong>1. ایجاد URL برای دریافت وب‌هوک</strong></p>
        <p>شما باید یک آدرس (URL) روی سرور خودتان ایجاد کنید که درخواست‌های وب‌هوک را دریافت و پردازش کند. این آدرس باید قابلیت پذیرش درخواست‌های HTTP <code>POST</code> را داشته باشد.</p>
        <p><strong>مثال:</strong></p>
        <pre style="text-align: left;direction: ltr">
    https://yourdomain.com/webhook-handler
    </pre>

        <p> <strong>2. ثبت URL وب‌هوک</strong></p>
        <ul>
          <li>وارد جزئیات اکانت مورد نظر شوید.</li>
          <li>در قسمت <strong>آدرس وب هوک</strong> آدرس URL خود را وارد کرده و تغییرات را ذخیره کنید.</li>
        </ul>

        <p><strong>3. نحوه کار وب‌هوک</strong></p>
        <p>با تنظیم وب‌هوک برای هر اکانت، پس از دریافت پیام توسط اکانت شما، یک درخواست با متد <code>POST</code> به آدرس تنظیم‌شده ارسال می‌شود.</p>

        <p><strong>4. ساختار درخواست وب‌هوک</strong></p>
        <p>وقتی پیامی دریافت می‌شود:</p>
        <ul>
          <li><strong>متد:</strong> <code>POST</code></li>
          <li><strong>بدنه (Payload):</strong> درخواست شامل اطلاعات رخداد به صورت JSON خواهد بود.</li>
        </ul>
        <p><strong>نمونه Payload:</strong></p>
        <pre style="text-align: left;direction: ltr">
    {
      "type": "message",
      "data": {
        "id": "3EB02B006EF2868845016A",
        "from": "989132222222@c.us",
        "to": "989131111111@c.us",
        "type": "chat",
        "fromMe": false,
        "body": "تست",
        "status": 1,
        "hasMedia": false,
        "file": ""
      }
    }
    </pre>

        <p><strong>5. نحوه پردازش درخواست</strong></p>
        <ol>
          <li>ابتدا مقدار <code>type</code> در بدنه درخواست را بررسی کنید که برابر با <code>message</code> باشد.</li>
          <li>اطلاعات پیام را از کلید <code>data</code> دریافت کنید.</li>
          <li>اگر پیام شامل فایل باشد:
            <ul>
              <li>مقدار <code>file</code> یک URL خواهد بود.</li>
              <li>باید فایل را فوراً ذخیره کنید، زیرا لینک فایل تنها تا 48 ساعت معتبر است و پس از آن حذف می‌شود.</li>
            </ul>
          </li>
        </ol>

        <p><strong>مثال داده‌ها</strong></p>
        <p>در اینجا توضیحات بیشتری درباره برخی از مقادیر کلیدی آورده شده است:</p>
        <ul>
          <li><code>id</code>: شناسه منحصر به فرد پیام.</li>
          <li><code>from</code>: شماره تلفن ارسال‌کننده پیام (به فرمت <code>989132222222@c.us</code>).</li>
          <li><code>to</code>: شماره تلفن دریافت‌کننده پیام.</li>
          <li><code>body</code>: متن پیام ارسال‌شده (در این مثال، "تست").</li>
          <li><code>status</code>: وضعیت پیام (1 به معنی دریافت موفق).</li>
          <li><code>hasMedia</code>: نشان‌دهنده وجود رسانه (عکس، ویدئو، فایل، ...).</li>
          <li><code>file</code>: لینک فایل ارسال‌شده (اگر موجود باشد). اگر فایل نباشد، این مقدار خالی خواهد بود.</li>
        </ul>

        <p><strong>6. ایمن‌سازی وب‌هوک</strong></p>
        <p>برای اطمینان از معتبر بودن درخواست‌ها می‌توانیم از <strong>JWT (JSON Web Token)</strong> استفاده کنیم. این توکن یک روش امن برای تأیید هویت و جلوگیری از دسترسی غیرمجاز است.</p>

        <p>1. ایجاد JWT</p>
        <ul>
          <li>هنگام تنظیم وب‌هوک، یک توکن JWT در سرور تولید کنید.</li>
          <li>این توکن را به عنوان یک <strong>query parameter</strong> به URL وب‌هوک اضافه کنید.</li>
        </ul>

        <p>2. ارسال وب‌هوک با توکن</p>
        <p>وقتی وب‌هوک ارسال می‌شود، این توکن در URL به شکل زیر قرار می‌گیرد:</p>
        <pre style="text-align: left;direction: ltr">
    https://yourdomain.com/webhook-handler?token=YOUR_JWT_TOKEN
    </pre>

        <hr>

        <h6>نکات مهم:</h6>
        <ul>
          <li>مطمئن شوید که URL شما در دسترس است.</li>
          <li>اگر آدرس وب‌هوک تغییر کرد، در تنظیمات سیستم آن را به‌روزرسانی کنید.</li>
          <li>به لاگ‌ها توجه کنید تا مشکلات احتمالی را بررسی کنید.</li>
          <li>اطمینان حاصل کنید که همیشه مقدار <code>type</code> را بررسی کرده و فقط در صورت برابر بودن با <code>message</code> آن را پردازش کنید.</li>
          <li>برای پیام‌های دارای فایل، حتماً فایل را ذخیره کنید تا از دست دادن آن جلوگیری شود.</li>
          <li>اطلاعات موجود در <code>file</code> شامل URL به فایل است. این فایل‌ها می‌توانند عکس‌ها، ویدئوها یا هر نوع رسانه دیگری باشند.</li>
          <li>توجه داشته باشید که درخواست‌های وب‌هوک به صورت <strong>POST</strong> ارسال می‌شوند و سرور شما باید آماده دریافت این نوع درخواست‌ها باشد.</li>

        </ul>
        <p>{{ $t('Webhook helper php desc') }}</p>
        <pre style="text-align: left;direction: ltr">
     &lt;?php
    // Get POST data
    $payload = file_get_contents('php://input');

    // Convert JSON to array
    $data = json_decode($payload, true);

    // Check if the message type is "message"
    if (isset($data['type']) && $data['type'] === 'message') {
        // Retrieve message data from the "data" key
        $messageData = $data['data'];

        // Print message details for review
        echo "Message ID: " . $messageData['id'] . PHP_EOL;
        echo "From: " . $messageData['from'] . PHP_EOL;
        echo "To: " . $messageData['to'] . PHP_EOL;
        echo "Body: " . $messageData['body'] . PHP_EOL;

        // Check if there is a file attached to the message
        if ($messageData['hasMedia'] && !empty($messageData['file'])) {
            $fileUrl = $messageData['file'];
            echo "File URL: " . $fileUrl . PHP_EOL;

            // Download and save the file
            $fileContent = file_get_contents($fileUrl);
            $filePath = __DIR__ . '/downloads/' . basename($fileUrl);

            // Create the "downloads" directory if it doesn't exist
            if (!is_dir(__DIR__ . '/downloads')) {
                mkdir(__DIR__ . '/downloads', 0777, true);
            }
            file_put_contents($filePath, $fileContent);
            echo "File saved to: " . $filePath . PHP_EOL;
        } else {
            echo "No file attached to the message." . PHP_EOL;
        }
    } else {
        echo "Invalid webhook payload or type is not 'message'." . PHP_EOL;
    }
    </pre>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import {
  BCard,
  BCardBody,
} from 'bootstrap-vue'
import store from '@/store'

export default {
  name: 'Documents',
  components: {
    BCard,
    BCardBody,
  },
  computed: {
    appConfig() {
      return store.state.app.appConfig
    },
  },
}
</script>
<style lang="scss" scoped>
pre {
  background-color: #2d2d2d;
  color: #f8f8f2;
  padding: 15px;
  border-radius: 8px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 16px;
  margin: 10px 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
pre code {
  font-size: 16px;
}
ul,ol{
  line-height: 2.5;
}
</style>
